import React from "react";

const StepsIcon = ({ id, text, currentStep, setCurrentStep, filledStatus }) => {
  const handleClick = () => {
    if (id <= filledStatus) {
      setCurrentStep(id);
    }
  };

  const isCurrent = id === currentStep;
  const isFilled = id < currentStep;

  return (
    <button
      onClick={handleClick}
      className="flex flex-col items-center justify-start w-[60px] z-10 cursor-pointer"
    >
      {isCurrent ? (
        <div className="w-6 h-6 rounded-full border border-[#008080] p-[1px] mb-1">
          <div className="w-full h-full bg-[#008080] rounded-full"></div>
        </div>
      ) : (
        <div
          className={`w-6 h-6 rounded-full mb-1 ${
            isFilled ? "bg-[#008080]" : "bg-[#9C9C9D]"
          }`}
        ></div>
      )}
      <p className="text-xs text-center text-[#0D1C2E] font-medium">{text}</p>
    </button>
  );
};

export default StepsIcon;
